<template>
  <div>
    <v-card class="mt-4 pt-2 pb-2" flat>
      aaaa
      <v-card-actions>
          <v-row>
              <v-col cols="12" md="6" sm="12">
                  <v-select
          v-model="SelStatus"
          :items="StatusName"
          item-text="event_name"
          item-value="event_id"
          label="Select Event"
          dense
          :rules="[(v) => !!v || 'Event is required']"
          required
        
          @change="getcompanyType"
          hide-details
          full-width
        ></v-select>
              </v-col>

              <v-col cols="12" md="6" sm="12">
                  <v-select
          v-model="SelCompanyType"
          :items="arrCompanyType"
          item-text="companytype_name"
          item-value="companytype_id"
          label="Select Company Type"
          dense
          :rules="[(v) => !!v || 'Company type is required']"
          required
        
          @change="getjobType"
          hide-details
          full-width
        ></v-select>
              </v-col>
  <v-col cols="12" md="6" sm="12">
                  <v-select
          v-model="SelVenue"
          :items="arrVenue"
          item-text="venue_name"
          item-value="venue_id"
          label="Select Venue"
          dense
          :rules="[(v) => !!v || 'Venue is required']"
          required
          
          @change="getAdmin"
          hide-details
          full-width
        ></v-select>
              </v-col>
             

<v-col cols="12" md="6" sm="12">
                  <v-select
          v-model="SelAdmin"
          :items="arrAdmin"
          item-text="name"
          item-value="eaid"
          label="Select Admin"
          dense
          :rules="[(v) => !!v || 'Select Admin is required']"
          required
          
          @change="clearData"
          hide-details
          full-width
        ></v-select>
              </v-col>

             

              
              
              <v-col cols="12" md="3" sm="12">
                   <v-btn color="primary"  raised dark large @click="load" >
          RELOAD

            </v-btn>
              <v-btn
          color="success"
          raised
          dark
          large
          @click="savechanges"
          class="ml-2"
        >
          SAVE CHANGES
        </v-btn>
              </v-col>
            
          </v-row>
        

        
       
      
      </v-card-actions>
    </v-card>
    <v-row>
      <v-col cols="12" md="6">
        <v-card flat>
          <v-card-text>Choose Jobtype(s)</v-card-text>

          <v-data-table
            v-model="selected"
            :headers="hdrreason"
            :items="arrreason"
            item-key="jobtype_id"
           
            
            dense
            :loading="loading"
            :search="search"
          >
            <template v-slot:top>
              <v-text-field
                v-model="search"
                label="Search"
                hide-details
                class="ml-4 mr-4 mb-5 mt-0 pt-0"
              ></v-text-field>
            </template>

              <template v-slot:item="{ item }">
              <tr>

<td> <v-btn
                 
              fab
              small
              dark
              color="green"
             outline
              class="ma-1"
              @click="editItem_BY(item)"
            >
              <v-icon center>mdi-plus</v-icon>
              
            </v-btn></td>

                <td>{{ item.jobtype_id }}</td>
                <td>{{ item.jobtype_name }}</td>
                
                 



              </tr>
            </template>



            

            <template v-slot:no-data>No Record(s)</template>
          </v-data-table>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card flat>
          <v-card-text>Selected Jobtype(s)</v-card-text>
          <v-data-table
            :headers="hdr1reason"
            :items="arr1reason"
            item-key="jobtype_id"
            dense
            :loading="loading"
            :search="search1"
          >
            <template v-slot:top>
              <v-text-field
                v-model="search1"
                label="Search"
                single-line
                hide-details
                class="ml-4 mr-4 mb-5 mt-0 pt-0"
              ></v-text-field>
            </template>
           

            <template v-slot:item="{ item }">
              <tr>

                <td> <v-btn
              
               fab
              small
              dark
             
             outline
              color="red"
              
              class="ma-1"
              @click="editItem_TO(item)"
            >
              <v-icon center>mdi-delete</v-icon>
              
            </v-btn></td>
                <td>{{ item.jobtype_id }}</td>
                <td>{{ item.jobtype_name }}</td>
 


              </tr>
            </template>



 

            <template v-slot:no-data>No Record(s)</template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbar" shaped top :color="snackbarcolor">
      {{ snackbartext }}
      <v-btn color="indigo" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data: () => ({
    successstatus:"primary",
    i:0,
    i_flag:"NEW",
    index:0,
    snackbar: false,
    snackbartext: "",
    snackbarcolor: "primary",
    loading: false,
    checkbox: "",
    chkselected: "",
    selected: [],
    StatusName: [],
    SelStatus: "",
    search: "",
    search1: "",
    btrue: true,
    SelCompanyType:"",
    arrCompanyType:[],
    SelVenue:"",
    arrVenue:[],

    SelAdmin:"",
    arrAdmin:[],
     SelJobType:"",
    arrJobType:[],
    inputclass: {
      eaid: 0,
      eid: 0,
      cid: 0,
      jid:[],
    },

    arrreason: [],
    hdrreason: [
       { text: "SELECT" },
      { text: "ID", value: "jobtype_id" },
      { text: "JOBTYPE NAME", value: "jobtype_name" },
     
    ],

    arr1reason: [],
    hdr1reason: [
      { text: "SELECT" },
      { text: "ID", value: "jobtype_id" },
      { text: "SELECTED JOBTYPE", value: "jobtype_name" },
    ],

    editedItem: {
      card_id: "",
      card_name: "",
      card_capacity:"0",
      event_id:"",
      mapping_status:"",
    },
  }),
  mounted() {
      this.$store.commit("setPageTitle","Job /Admin Map");
     // this.$store.commit("setPageTitle", "Stand Master");
    this.bindEvent();
    // this.Gridbindjobtype();
    // this.Gridbindjobtype(4);
  },
  watch: {
    selected: function () {
    },
    bindEvent: function(){
      
    }

  },
  methods: {
    showSnackbar: function (scolor, stext) {
      this.snackbar = true;
      this.snackbartext = stext;
      this.snackbarcolor = scolor;
    },

    addvalue: function (id, name, cid, status) {
      //alert(id + " " + name + " " + cid + " " + status);
      
      console.log(status);
      this.editedItem.reason_id = id;
      this.editedItem.reason_name = name;
      this.editedItem.status_id = cid;
      this.editedItem.mapping_status = "true";
      this.editedItem.card_capacity="0",
      this.arr1reason.push(this.editedItem);
      //  this.arr1jobtype.splice()
    },
    clearData: function () {
      this.arrreason = [];
      this.arr1reason=[];
      this.selected = [];
      
    },

    getcompanyType:function(){
this.bindCompanyType(this.SelStatus);
this.bindVenue(this.SelStatus);
    },

getAdmin:function(){
this.bindAdmin(this.SelStatus,this.SelVenue);
},
      getjobType:function(){
         this.arrJobType=[];
         this.SelJobType="";
this.bindJobType(this.SelCompanyType);
    },



    editItem_BY: function (item) {
     //  this.inputclass.cid = [];
    // this.arr1reason=[];
    this.successstatus="success";
    this.i_flag="";
    this.i_flag="NEW";
    this.editedItem=[];
       this.editedItem.jobtype_id = item.jobtype_id;
      this.editedItem.jobtype_name = item.jobtype_name;
      this.editedItem.card_capacity ="0";
      if(this.arr1reason.length==0)
      {
this.arr1reason.push(this.editedItem);
this.arrreason.splice(this.arrreason.indexOf(item),1);



      }
      else{

for(this.i=0;this.i<=this.arr1reason.length-1;this.i++)
{
 // alert(this.arr1reason[this.i]["card_id"] + "/" + item.card_id);
  if(this.arr1reason[this.i]["jobtype_id"]== item.jobtype_id)
  {
    
    this.i_flag="EXIST";
    return;
  }
}

//alert(this.i_flag);
if(this.i_flag=="NEW"){
  
this.arr1reason.push(this.editedItem);
this.arrreason.splice(this.arrreason.indexOf(item),1);

}

      }
  //this.selected = this.arrreason.filter(
          //   (task) => task.card_id == this.inputclass.cid
         // );

    },

    editItem_TO: function (item) {
 this.editedItem=[];
 this.editedItem.jobtype_id=item.jobtype_id;
 this.editedItem.jobtype_name=item.jobtype_name;

      this.arr1reason.splice(this.arr1reason.indexOf(item),1);
     this.arrreason.push(this.editedItem);
//  this.selected = this.arrreason.filter(
//             (task) => task.card_id == this.inputclass.cid
//           );

    },

    
    load: function () {
      //alert(SelStatus.)
    //  alert(this.SelStatus.event_name);
      this.selected = [];
      this.loading = true;
      this.Gridbindjobtype(this.SelStatus,this.SelCompanyType,this.SelAdmin);
    },
    savechanges: function () {
      //this.SelStatus,this.SelCompanyType,this.SelJobType

      // if(this.arr1reason.length<=0)
      // {
      //   this.showSnackbar("error", "Select Card before save !");
      // return;
      // }

      this.inputclass.jid=[];
      this.inputclass.eaid = this.SelAdmin;
      this.inputclass.eid = this.SelStatus;
      this.inputclass.cid = this.SelCompanyType;
      this.arr1reason.forEach((el) => {
        this.inputclass.jid.push(el.jobtype_id);
      });
      //console.log("TRY1");
console.log(this.inputclass);
      axios
        .post(this.$apiPath + "AdminAccess" , this.inputclass, {
          headers: { Appkey: this.$aKey },
        })
        .then((res) => {
          if (res.data.status == "Success") {
            this.showSnackbar("Success", "Admin access merged with jobtype !");
             this.Gridbindjobtype(this.SelStatus,this.SelCompanyType,this.SelAdmin);
          }
        })
        .catch()
        .finally();
    },

    handleClick(value) {
      alert(value);
    },
    bindEvent: async function () {
      await axios
        .get(this.$apiPath + "Event", {
          headers: { Appkey: this.$aKey },
        })
        .then((res) => {
          this.StatusName = res.data.result;
        })
        .catch()
        .finally();
    },

    bindVenue:async function (eid) {
      
        await axios
        .get(this.$apiPath + "Venue/GetByEId/" + eid,{
            headers: { Appkey: this.$aKey},
        })
        .then((res) => {
            this.arrVenue=res.data.result;
        })
        .catch()
        .finally();
    },

    bindAdmin:async function (eid,vid) {
await axios
.get(this.$apiPath + "EventAdmin/GetByEIdVID/" + eid + "/" + vid,
{headers: { Appkey: this.$aKey}},
)
.then((res) => {   
     this.arrAdmin=res.data.result;
    })
    .catch()
    .finally(); 
    },




 bindCompanyType: async function (eid) {
      await axios
        .get(this.$apiPath + "CompanyType/GetByEventId/" + eid, {
          headers: { Appkey: this.$aKey },
        })
        .then((res) => {
          this.arrCompanyType = res.data.result;
        })
        .catch()
        .finally();
    },

    
 bindJobType: async function (ctid) {
      await axios
        .get(this.$apiPath + "VendorApp/getJobtype/" + ctid, {
          headers: { Appkey: this.$aKey },
        })
        .then((res) => {
          this.arrJobType = res.data.result;
        })
        .catch()
        .finally();
    },



    Gridbindjobtype: async function (eid,ctid,eaid) {
    //  alert(eid + "/"  + cid + "/" + jid);
      await axios
        .get(this.$apiPath + "AdminAccess/ByJobtype/" + eid + "/" + ctid + "/" + eaid, {
          headers: { Appkey: this.$aKey },
        })
        .then((res) => {
           // console.log("BIIIII");
         // console.log( res.data.result);
          this.arrreason = res.data.result;
        //  this.arr1reason = res.data.result;
        //alert(this.arrreason.jobtype_id);
          this.arr1reason = this.arrreason.filter(
            (task) => task.mapping_status == 'true'
          );

          this.arrreason= this.arrreason.filter(n => !this.arr1reason.includes(n));

        })
        .catch()
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>